import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const AdminLayout = ({ children }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('isAuthenticated');
    navigate('/admin/login');
  };

  return (
    <div className="container-fluid">
      <div className="row">
        {/* Sidebar */}
        <div className="col-md-3 col-lg-2 admin-sidebar">
          <div className="d-flex flex-column p-3">
            <h4 className="text-white text-center mb-4">Admin Panel</h4>
            <ul className="nav nav-pills flex-column">
              <li className="nav-item">
                <Link to="/admin/dashboard" className="nav-link">
                  <i className="fas fa-tachometer-alt me-2"></i>
                  Dashboard
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/admin/customers" className="nav-link">
                  <i className="fas fa-users me-2"></i>
                  Customers
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/admin/measurements" className="nav-link">
                  <i className="fas fa-ruler me-2"></i>
                  Measurements
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/admin/orders" className="nav-link">
                  <i className="fas fa-shopping-cart me-2"></i>
                  Orders
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/admin/services" className="nav-link">
                  <i className="fas fa-concierge-bell me-2"></i>
                  Services
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/admin/gallery" className="nav-link">
                  <i className="fas fa-images me-2"></i>
                  Gallery
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/admin/reports" className="nav-link">
                  <i className="fas fa-chart-bar me-2"></i>
                  Reports
                </Link>
              </li>
            </ul>
            <hr className="bg-white"/>
            <button onClick={handleLogout} className="btn btn-outline-light">
              <i className="fas fa-sign-out-alt me-2"></i>
              Logout
            </button>
          </div>
        </div>

        {/* Main content */}
        <div className="col-md-9 col-lg-10 admin-content">
          {children}
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;